import { pathOr, values } from 'ramda';
import { i18n } from 'invision-core';
import LocaleKeys from '../../../locales/keys';
import { OPT_OUT_PROCESS_CREDIT_PAYMENT_SELECTION, DIRECT_DEBIT, DD_SUB_TYPE_NETHERLANDS, SUPPORTED_PAYMENT_INSTRUMENT_TYPES } from './ewallet.constants';
export var getFormattedExpirationForCard = function getFormattedExpirationForCard() {
  var card = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var month = pathOr('', ['ExpirationMonth'], card).toString();
  var year = pathOr('', ['ExpirationYear'], card).toString().slice(-2);
  var separator = month.length > 0 && year.length > 0 ? '/' : '';
  return "".concat(month).concat(separator).concat(year);
};
export var isPaymentSelectable = function isPaymentSelectable(paymentInstrument) {
  var isPaymentSelectable = true;
  if (paymentInstrument.Type === parseInt(DIRECT_DEBIT)) {
    if (paymentInstrument.DirectDebit && paymentInstrument.DirectDebit.Type === parseInt(DD_SUB_TYPE_NETHERLANDS)) {
      isPaymentSelectable = false;
    }
  } else {
    return !values(OPT_OUT_PROCESS_CREDIT_PAYMENT_SELECTION).includes(String(paymentInstrument.Type));
  }
  return isPaymentSelectable;
};
export var paymentTypeNameIdentifier = function paymentTypeNameIdentifier(paymentInstrument) {
  if (paymentInstrument.Type === parseInt(SUPPORTED_PAYMENT_INSTRUMENT_TYPES.STORED_VALUE_ACCOUNT) && paymentInstrument.StoredValueAccount.LoyaltyCard) {
    return i18n.translate(LocaleKeys.E_WALLET.STORED_VALUE_ACCOUNT.LOYALTY_CARD);
  }
  return paymentInstrument.TypeName;
};